export default __webpack_public_path__ + "static/MessinaSansWeb-BookItalic-2dc6258a05f8ba03a2abc6a698c5ac6c.woff";